import Cookies from 'js-cookie';
import axios from 'axios'


let baseURL = document.querySelector('body').getAttribute('data-api-domain');
let api = axios.create({
  baseURL: baseURL + '/api/',
  // на silverstripe иногода вылетает.
  // timeout: 3000,
  timeout: 9000,
  // headers: {
  //   'Content-Type': 'multipart/form-data'
  // },
  transformRequest: [function (data, headers) {
    let token = Cookies.get('token') || '';
    headers.Authorization = `Bearer ${token}`
    return data;
  }],
});
export default api



// WEBPACK FOOTER //
// ./src/helpers/api.js